import InvestToRangeInterface from "./RangeDetails";

export default InvestToRangeInterface;
